import { render } from "./CustomerShowComponent.vue?vue&type=template&id=11b3ca26"
import script from "./CustomerShowComponent.vue?vue&type=script&lang=js"
export * from "./CustomerShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/customers/CustomerShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11b3ca26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11b3ca26', __exports__)) {
    api.reload('11b3ca26', __exports__)
  }
  
  module.hot.accept("./CustomerShowComponent.vue?vue&type=template&id=11b3ca26", () => {
    api.rerender('11b3ca26', render)
  })

}


export default __exports__